import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RoleContext } from "../RoleContext";
import { API_URL } from "../config";
import Logo from "../assets/img/logo.png";
import Coverimg from "../assets/img/cover.jpg";

const Login = () => {
  const navigate = useNavigate();
  const { setUser, setToken } = useContext(RoleContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleLogin = async () => {
    try {
      const response = await fetch(`${API_URL}login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const result = await response.json();

      if (response.ok) {
        const { token, data } = result;
        setToken(token[0].token);
        setUser(data[0]); // Assuming data[0] contains user details

        navigate("/dashboard");
      } else {
        setErrorMessage(result.message || "Login failed. Please try again.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
      console.error(error);
    }
  };

  return (
    <div
      className="flex flex-col min-h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${Coverimg})` }}
    >
      {/* Main Section */}
      <div className="flex flex-1 flex-col lg:flex-row items-center lg:justify-center p-4 lg:p-10">
        {/* Left Section: Image */}
        <div className="flex-1 hidden lg:flex items-center justify-center"></div>

        {/* Right Section: Login Form */}
        <div className="flex-1 w-full max-w-sm bg-white p-6 lg:p-8 rounded-lg shadow-lg">
          <div className="flex flex-col items-center">
            <div className=" mb-4">
              <img src={Logo} alt="Logo" className="w-40 h-40 " />
            </div>

            <h2 className="text-black text-xl font-bold mb-4">Login</h2>
            {errorMessage && (
              <div className="text-red-500 mb-4 text-center">
                {errorMessage}
              </div>
            )}
            <input
              type="text"
              placeholder="Email id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 mb-4 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 mb-4 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
            <button
              onClick={handleLogin}
              className="bg-blue-600 text-white px-4 py-2 rounded w-full hover:bg-blue-700 transition"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
